import { useClerk, useOrganization } from '@clerk/react'
import { type PropsWithChildren, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'

import { useToast } from '@/hooks/useToast'
import type { OrganizationParams } from '@/lib/workspace/routerTypes'

export const OrganizationMiddleware = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate()
  const { organizationId } = useParams() as Readonly<OrganizationParams>
  const { setActive } = useClerk()
  const { isLoaded, organization } = useOrganization()
  const { toast } = useToast()

  const shouldSwitchOrganization =
    !!organizationId && isLoaded && organization?.id !== organizationId

  useEffect(() => {
    if (!shouldSwitchOrganization) {
      return
    }

    Promise.resolve(setActive({ organization: organizationId })).catch(() => {
      toast({
        title: 'Could not open organization',
        description:
          "We couldn't switch to this organization. Please choose one from your organizations list.",
        variant: 'destructive',
      })
      navigate('/organizations', { replace: true })
    })
  }, [navigate, organizationId, setActive, shouldSwitchOrganization, toast])

  return <>{children}</>
}
